import moment from 'moment-timezone';
import {status} from '../../../utils/constant';
import {
  convertNetworkInvitationsFromAPI,
  convertNetworkInvitationsToAPI,
  convertSuggestionsFromAPI
} from '../helper';
import {invitationsInDb, suggestionsInDb} from './data/network';

function inviteSubcontractors(_organisationId, invitations) {
  invitationsInDb.push(
    convertNetworkInvitationsToAPI([{
      ...invitations[0],
      creationDate: moment().format('YYYY-MM-DDTHH:mm:ss')
    }])
  );
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}

function inviteClients(_organisationId, invitations) {
  invitationsInDb.push(
    convertNetworkInvitationsToAPI([{
      ...invitations[0],
      creationDate: moment().format('YYYY-MM-DDTHH:mm:ss')
    }])
  );
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}

function pendingInvitationExists(invitationId) {
  return Promise.resolve(
    invitationsInDb.some(invitation => invitation.id === invitationId)
  );
}

function cancelPendingInvitation(invitationId) {
  return new Promise((resolve, reject) => {
    const index = invitationsInDb.findIndex(el => el.id === invitationId);
    if (index === -1) { reject(); }
    const deleted = invitationsInDb.splice(index, 1);
    if (deleted.length !== 1) { reject(); }
    resolve();
  });
}

function resendInvitation(invitationId, reason) {
  return new Promise((resolve, reject) => {
    const index = invitationsInDb.findIndex(el => el.id === invitationId);
    if (index === -1) { reject(); }
    invitationsInDb[index] = {
      ...invitationsInDb[index],
      resendReason: reason,
      lastSentDate: moment().format('YYYY-MM-DDTHH:mm:ss')
    };
    resolve();
  });
}

function searchInvitations(data) {
  return new Promise(resolve => {
    const res = invitationsInDb.filter(el => {
      if (data.statuses && !data.statuses.some(s => el.status === s)) {
        return false;
      }
      return Object.keys(data).every(key => data[key] === el[key]);
    });
    resolve(convertNetworkInvitationsFromAPI(res));
  });
}

function getPendingOrRejectedInvitations(invitingId) {
  return searchInvitations({statuses: [status.PENDING, status.REJECTED], ...invitingId});
}

function getInvitationsSentToSubcontractor(invitingOrganisationId) {
  return getPendingOrRejectedInvitations({invitingClientId: invitingOrganisationId});
}

function getInvitationsSentToClient(invitingOrganisationId) {
  return getPendingOrRejectedInvitations({invitingSubcontractorId: invitingOrganisationId});
}

function getSuggestions(_subcontractorId) {
  return new Promise(resolve => {
    const res = suggestionsInDb;
    resolve(convertSuggestionsFromAPI(res));
  });
}

function acceptSuggestion(_organisationId, _invitationId) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}

function rejectSuggestion(_organisationId, _invitationId, _rejectionReason) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}

export default {
  inviteSubcontractors,
  inviteClients,
  pendingInvitationExists,
  cancelPendingInvitation,
  resendInvitation,
  searchInvitations,
  getInvitationsSentToSubcontractor,
  getInvitationsSentToClient,
  getSuggestions,
  acceptSuggestion,
  rejectSuggestion
};
